import { ApolloClient } from 'apollo-client';
import { withClientState } from 'apollo-link-state';
import gql from "graphql-tag"
import { InMemoryCache } from 'apollo-cache-inmemory';
import { defaults, resolvers, typeDefs } from "./../data-services/state-management/index"
const cache = new InMemoryCache();

const client = new ApolloClient({
  cache,
  link: withClientState({ resolvers, defaults, cache, typeDefs }),
});




export default client;